<template>
  <div class="collectpopup" v-if="dataVal.flag">
    <div class="collect">
      <div class="collect_head">
        <div class="collect_head_close"></div>
        <div class="collect_head_title">收藏信息</div>
        <div class="collect_head_close" @click="handleRefund">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="collect_info">
        <div class="collect_info_item">
          <div class="collect_info_item_l">中文标题：</div>
          <div class="collect_info_item_r1">
            <el-input v-model="fromData.title" placeholder="请输入中文标题"></el-input>
          </div>
        </div>
        <div class="collect_info_item">
          <div class="collect_info_item_l">英文标题：</div>
          <div class="collect_info_item_r1">
            <el-input v-model="fromData.title_en" placeholder="请输入英文标题"></el-input>
          </div>
        </div>
        <div class="collect_info_item">
          <div class="collect_info_item_l">中文内容：</div>
          <div class="collect_info_item_r1">
            <Editor :height="'56vh'" :placeholder="'请输入中文内容'" :value="fromData.content" ref="editor"></Editor>
          </div>
        </div>
        <div class="collect_info_item">
          <div class="collect_info_item_l">英文内容：</div>
          <div class="collect_info_item_r1">
            <Editor :height="'56vh'" :placeholder="'请输入英文内容'" :value="fromData.content_en" ref="editor_en"></Editor>
          </div>
        </div>
      </div>
      <div class="collect_btn">
        <div class="collect_btn_cancel" @click="handleRefund">取消</div>
        <div class="collect_btn_cancel collect_btn_submit" @click="handleSubmit">
          提交
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Editor from "@/components/Editor.vue";
export default {
  components: { Editor },
  name: "collect",
  props: ["dataVal"],
  data() {
    return {
      headers: {
        token: localStorage.token,
      },

      fromData: {
        title: "",
        title_en: "",
        content: "",
        content_en: "",
        id: "",
      },
      urls: localStorage.getItem('baseURL'),
      linkArr: [localStorage.getItem('baseURL')],
      flag: false,
    };
  },
  methods: {
    //取消弹窗
    handleRefund() {
      let data = {
        flag: false,
        submitFlag: false,
      };
      this.$emit("addHelpRecordCell", data);
    },
    // 定义一个函数来替换文本中的域名
    replaceDomains(text, domains) {
      // 遍历每个域名并替换文本中的域名为空字符串
      domains.forEach((domain) => {
        const domainRegex = new RegExp(`\\b${domain}\\b`, "g"); // 使用正则表达式匹配整个域名
        text = text.replace(domainRegex, "");
      });
      return text;
    },
    async handleSubmit() {
      if (!this.flag) {
        this.flag = true;
        //中文内容
        let str_zh = this.replaceDomains(
          this.$refs.editor.contentValue,
          this.linkArr
        );
        this.fromData.content = str_zh;
        //英文内容
        let str_en = this.replaceDomains(
          this.$refs.editor_en.contentValue,
          this.linkArr
        );
        this.fromData.content_en = str_en;
        //提交
        let res = await this.$api.indexHelpedit({
          ...this.fromData,
        });
        if (res.code == 1) {
          let obj = {
            flag: false, //弹窗是否显示
            submitFlag: true, //是否调用接口
            data: this.fromData,
          };
          this.$message.success(res.msg);
          this.$emit("addHelpRecordCell", obj);
          setTimeout(() => {
            this.flag = false;
          }, 2000);
        } else {
          let str = this.fromData.content;
          // 使用正则表达式匹配并替换链接地址
          str = str.replace(/href="\/([^"]+)"/g, `href="${this.urls}/$1"`);
          str = str.replace(/src="\/([^"]+)"/g, `src="${this.urls}/$1"`);
          this.fromData.content = str;
          let str2 = this.fromData.content_en;
          // 使用正则表达式匹配并替换链接地址
          str2 = str2.replace(/href="\/([^"]+)"/g, `href="${this.urls}/$1"`);
          str2 = str2.replace(/src="\/([^"]+)"/g, `src="${this.urls}/$1"`);
          this.fromData.content_en = str2;
          this.flag = false;
        }
      }
    },
    //帮助详情
    async indexHelpdetail(id) {
      let res = await this.$api.indexHelpdetail({ id });
      if (res.code == 1) {
        this.fromData.title = res.data.title;
        this.fromData.title_en = res.data.title_en;
        // this.fromData.content = res.data.content;
        // this.fromData.content_en = res.data.content_en;
        this.fromData.id = res.data.id;
        let str = res.data.content;
        // 使用正则表达式匹配并替换链接地址
        str = str.replace(/href="\/([^"]+)"/g, `href="${this.urls}/$1"`);
        str = str.replace(/src="\/([^"]+)"/g, `src="${this.urls}/$1"`);
        this.fromData.content = str;
        let str2 = res.data.content_en;
        // 使用正则表达式匹配并替换链接地址
        str2 = str2.replace(/href="\/([^"]+)"/g, `href="${this.urls}/$1"`);
        str2 = str2.replace(/src="\/([^"]+)"/g, `src="${this.urls}/$1"`);
        this.fromData.content_en = str2;
      }
    },
  },
  watch: {
    dataVal: {
      handler(newValue, oldValue) {
        if (newValue.id && newValue.flag) {
          this.indexHelpdetail(newValue.id);
        } else {
          this.fromData.title = "";
          this.fromData.title_en = "";
          this.fromData.content = "";
          this.fromData.content_en = "";
          this.fromData.id = "";
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.collectpopup {
  width: 100vw;
  height: 100vh;
  background-color: rgba($color: #000000, $alpha: 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;

  .collect {
    width: 80vw;
    background-color: #fff;
    border-radius: 16px;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .collect_head {
      width: 100%;
      height: 50px;
      background-color: #f6f6f6;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;

      .collect_head_close {
        width: 20px;
        height: 20px;
        cursor: pointer;

        .el-icon-close {
          font-size: 20px;
          color: #999999;
          cursor: pointer;
        }
      }

      .collect_head_title {
        font-size: 16px;
        color: #333333;
        cursor: default;
      }
    }

    .collect_info {
      width: 100%;
      display: flex;
      flex-direction: column;
      padding: 0 37px 0 29px;
      height: 76vh;
      overflow-y: auto;
      margin-top: 10px;

      .collect_info_item {
        width: 100%;
        display: flex;
        margin-top: 20px;

        .collect_info_item_l {
          width: 100px;
          height: 32px;
          line-height: 32px;
          font-size: 14px;
          letter-spacing: 1px;
          color: #333333;
          text-align: right;
          padding-right: 10px;
        }

        .collect_info_item_r1 {
          width: calc(100% - 100px);
        }

        .collect_info_item_r2 {
          width: calc(100% - 100px);
        }

        .collect_info_item_r3 {
          width: calc(100% - 100px);
          height: 200px;
          background-color: #f9f9f9;
          border-radius: 4px;
          border: solid 1px #dbdbdb;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          z-index: 101;

          img {
            max-width: 100%;
            max-height: 100%;
          }

          .collect_info_item_r_tip {
            display: flex;
            align-items: center;

            .el-icon-download {
              font-size: 16px;
              color: #999999;
            }

            span {
              font-size: 14px;
              color: #999999;
              margin-left: 10px;
            }
          }

          .cen_body_mtr_img_unload {
            width: 100%;
            height: 100%;
            opacity: 0;
            position: absolute;
            z-index: 102;

            /deep/.avatar-uploader {
              width: 100%;
              height: 100%;

              .el-upload {
                width: 100%;
                height: 100%;
              }
            }
          }

          .cen_body_mtr_img_pro {
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 103;

            /deep/.el-progress {
              width: 108px;
              height: 108px;
              padding: 10px;

              .el-progress-circle {
                width: 100% !important;
                height: 100% !important;
              }
            }
          }

          .cen_body_mtr_img_close {
            width: 20px;
            height: 20px;
            background-color: #000;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: 0;
            right: 0;
            z-index: 104;
            cursor: pointer;

            .el-icon-close {
              font-size: 16px;
            }
          }
        }
      }
    }

    .collect_btn {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 30px 37px 26px 37px;

      .collect_btn_cancel {
        width: 80px;
        height: 32px;
        font-size: 14px;
        color: #606266;
        background-color: #ffffff;
        border-radius: 4px;
        border: solid 1px #dbdbdb;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 10px;
        cursor: pointer;
      }

      .collect_btn_submit {
        color: #ffffff;
        border: solid 1px #e64a19;
        background-color: #e64a19;
      }
    }
  }
}
</style>